import React from 'react';
import { connect as reduxConnect } from 'react-redux';
import organizationActions from '../../../actions/organization';

const renderWrappedComponent = Component =>
  // eslint-disable-next-line react/prefer-stateless-function
  class extends React.Component {
    componentDidMount= () => {
      // eslint-disable-next-line react/prop-types
      const { organizationTransferToken, setOrganizationsValue, selectedInvite } = this.props;
      // eslint-disable-next-line react/prop-types
      if (!organizationTransferToken && !selectedInvite.uuid) {
        setOrganizationsValue('openOrganizationTransferSuccessModal', false);
      }
    }

    handleClose = () => {
      // eslint-disable-next-line react/prop-types
      const { setOrganizationsValue } = this.props;
      setOrganizationsValue('openOrganizationTransferSuccessModal', false);
      setOrganizationsValue('organizationTransferToken', '');
    }

    render() {
      // eslint-disable-next-line
      const { organizationTransferToken, openOrganizationTransferSuccessModal, selectedInvite } = this.props;
      return (<Component
        // eslint-disable-next-line
        open={(organizationTransferToken || selectedInvite.uuid) && openOrganizationTransferSuccessModal}
        onClose={this.handleClose}
        {...this.props}
      />);
    }
  };


const mapStateToProps = ({ organizationInvites }) => ({
  openOrganizationTransferSuccessModal:
    organizationInvites.openOrganizationTransferSuccessModal,
  organizationTransferToken: organizationInvites.organizationTransferToken,
  selectedInvite: organizationInvites.selectedInvite,
});

const connect = WrappedComponent =>
  reduxConnect(mapStateToProps, {
    setOrganizationsValue: organizationActions.setOrganizationsValue,
  })(renderWrappedComponent(WrappedComponent));

export default connect;
